import React from "react";
import { Grid } from "@mui/material";

/**
 * @typedef {Object} CustomRowProps
 * @property {React.ReactNode} children
 * @property {SxProps<Theme>} sx
 */

/**
 * @param {CustomRowProps} param0
 * @returns {JSX.Element} Dropdown component
 */
const Row = ({ children, ...props }) => {
  return (
    <Grid container {...props} sx={{ marginInline: "-5px", ...props.sx }}>
      {children}
    </Grid>
  );
};

export default Row;
